import {axiosInstance} from '../axiosInstance';

/** POST `/executor_web/self_employment/validation` — проверка СМЗ в ФНС (тела нет, ИНН должен быть сохранён через PATCH identification/inn) */
export function validateSelfEmployment(signal?: AbortSignal) {
	return axiosInstance.post<void>('self_employment/validation', undefined, {signal});
}
